import { render, staticRenderFns } from "./myFamilyQr.vue?vue&type=template&id=75b36f8e&scoped=true&"
import script from "./myFamilyQr.vue?vue&type=script&lang=js&"
export * from "./myFamilyQr.vue?vue&type=script&lang=js&"
import style0 from "./myFamilyQr.vue?vue&type=style&index=0&id=75b36f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b36f8e",
  null
  
)

export default component.exports